import React, { Suspense, useRef, useLayoutEffect } from 'react';

import {
  useSlateStatic,
  ReactEditor
} from 'slate-react';

import useOnClickOutside from 'generics/hooks/on-click-outside';

import Helpers from '../../helpers';

import MentionPanel from './lazy';
import { positionMentionInput } from './overlay-position';
import { getMentionTypes, getMentionInputPlaceholder } from './mention-types';

import './index.scss';

function Mention(props) {

  const { attributes, children, element } = props;
  const mentionOptions = element.mentionOptions;

  const editor = useSlateStatic();

  const mentionAnchorReference = useRef(null);
  const inputContainerReference = useRef(null);

  useOnClickOutside(inputContainerReference, handleMentionNodeUnwrap);

  useLayoutEffect(function positionInputOnLoad() {

    tryPositionInput();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mentionOptions.selected]);

  function tryPositionInput() {

    if (inputContainerReference.current === null) {
      return;
    }

    positionMentionInput(inputContainerReference.current, mentionAnchorReference.current);

  }

  function handleMentionNodeUnwrap() {

    let text = `@${mentionOptions.searchText}`;

    if (mentionOptions.searchText === null) {
      text = '@';
    }

    const elementPath = ReactEditor.findPath(editor, element);

    Helpers.mention.unwrapNode(editor, text, elementPath);

  }

  function renderAnchor() {

    if (mentionOptions.selected === true) {
      return;
    }

    return <span className="mention-anchor" ref={mentionAnchorReference}>@</span>;

  }

  function focusPlaceholderInputControl(inputControl) {

    if (inputControl === null) {
      return;
    }

    if (document.activeElement === inputControl) {
      return;
    }

    inputControl.focus();

  }

  function renderPanelPlaceholder() {

    const placeholderInputControlAttributes = {
      type: 'text',
      className: 'mention-input-control',
      placeholder: getMentionInputPlaceholder(getMentionTypes(editor)),
      readOnly: true,
      value: '',
      ref: focusPlaceholderInputControl
    };

    return <React.Fragment>
      <ht-spinner size="14" />
      <input {...placeholderInputControlAttributes} />
    </React.Fragment>;

  }

  function renderInputContainer() {

    if (mentionOptions.selected === true) {
      return;
    }

    const inputContainerAttributes = {
      className: 'mention-input-control-container',
      ref: inputContainerReference
    };

    const mentionPanelProperties = {
      element,
      anchorReference: inputContainerReference,
      onUnwrap: handleMentionNodeUnwrap
    };

    return <div {...inputContainerAttributes}>
      <Suspense fallback={renderPanelPlaceholder()}>
        <MentionPanel {...mentionPanelProperties} />
      </Suspense>
    </div>;

  }

  function renderChildren() {

    if (mentionOptions.selected === false) {
      return children;
    }

    return <span className="mention-handle">{children}</span>;

  }

  function renderMain() {

    const mentionMainAttributes = {
      ...attributes,
      className: 'mention-element',
      contentEditable: false
    };

    return <div {...mentionMainAttributes}>
      {renderAnchor()}
      {renderInputContainer()}
      {renderChildren()}
    </div>;

  }

  return renderMain();

}

export default Mention;
